<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-form ref="form">
          <v-container class="py-0">
            <v-toolbar-title>{{$t('keywords.register') }}</v-toolbar-title>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  :readonly="isUpdating"
                  :rules="alphaNumericRules(objEditar.parameterName)"
                  name="parameterName"
                  :label="$t('parameter.param.key')"
                  v-model="objEditar.parameterName"
                />
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  :rules="requiredRules(objEditar.parameterValue)"
                  name="parameterValue"
                  :label="$t('parameter.param.value')"
                  v-model="objEditar.parameterValue"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  name="description"
                  :label="$t('parameter.param.description')"
                  v-model="objEditar.parameterDescription"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn color="success" class="mr-0" @click="saveItem">{{ $t('button.save') }}</v-btn>
        <v-btn color="blue darken-1" text @click="close">{{ $t('button.cancel') }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/ParameterService'
import LocalStorageService from '../../services/LocalStorageService'
import { alphaNumericRules, requiredRules } from '../../utils/rules'

export default {
  name: 'ParameterForm',

  props: {
    identifier: String
  },

  data: () => ({
    alphaNumericRules,
    requiredRules,
    objEditar: {
      parameterName: '',
      parameterDescription: '',
      parameterValue: '',
      type: '',
      clientPrefix: ''
    },
    isUpdating: false
  }),

  mounted () {
    this.loadDB()
  },

  methods: {
    loadDB () {
      if (this.identifier) {
        Servico.findById(this.identifier)
          .then(response => {
            this.isUpdating = true
            this.objEditar = response.data
          })
          .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
      }
    },

    saveItem () {
      this.objEditar.lastModifiedBy = LocalStorageService.getUsername()
      this.objEditar.clientPrefix = LocalStorageService.getClientPrefix()
      if (this.$refs.form.validate()) {
        if (this.isUpdating) this.updateItem()
        else this.createItem()
      } else {
        this.$message.error(this.$t('warnings.validation.fill_required_fields'))
      }
    },

    createItem () {
      Servico.insert(this.objEditar)
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    updateItem () {
      Servico.update(this.objEditar)
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    close () {
      this.$emit('editItem', true, null)
    }
  }
}
</script>
